import React, { useEffect, useState } from 'react';
import { Col, Row, Card, Button, Spinner } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../Global.css';
import Navbar from '../components/Navbar';
import { useNavigate } from "react-router-dom";
import api from '../api';

function Health() {
  const [latest, setLatest] = useState(null);
  const [history, setHistory] = useState([]); // Geçmişi tarayıcıda anlık biriktiriyoruz
  const [loading, setLoading] = useState(true);
  const [checking, setChecking] = useState(false);
  const [error, setError] = useState(null);

  const navigate = useNavigate();
  const token = localStorage.getItem('JWTTOKEN');

  const getStatusColor = (status) => {
    if (status === "OK") return "#029220";
    if (status === "DEGRADED") return "#e0a800";
    return "#c0392b"; // Hata veya UNREACHABLE
  };

  const formatDate = (ts) => {
    if (!ts) return "—";
    return new Date(ts).toLocaleTimeString('tr-TR', {
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    });
  };

  const fetchHealthData = async (isManual = false) => {
    if (isManual) setChecking(true);
    
    const checkedAt = new Date().toISOString();

    try {
      // Backend /health endpoint'in body içinde passcode bekliyorsa:
      // NOT: Eğer endpoint yolun farklıysa ("/v1/health" gibi) güncelleyebilirsin.
      const res = await api.post("/v1/util/health", {
        passcode: process.env.REACT_APP_HEALTH_TOKEN || "CLOUDFLARE_HEALTH_TOKEN"
      });

      const resultData = res.data;

      const healthRecord = {
        checkedAt,
        reachable: true,
        httpStatus: res.status,
        status: resultData?.status || "OK",
        data: resultData
      };

      setLatest(healthRecord);
      // Yeni gelen kaydı listenin başına ekle, en fazla 40 kayıt tut
      setHistory((prev) => [healthRecord, ...prev].slice(0, 40));
      setError(null);

    } catch (err) {
      console.error("Health kontrol hatası:", err);

      // Sunucu 503 döndüğünde axios hata fırlatabilir, yanıt içeriğini kontrol et
      if (err.response && err.response.data && err.response.data.services) {
        const resultData = err.response.data;
        const degradedRecord = {
          checkedAt,
          reachable: true,
          httpStatus: err.response.status,
          status: resultData?.status || "DEGRADED",
          data: resultData
        };
        setLatest(degradedRecord);
        setHistory((prev) => [degradedRecord, ...prev].slice(0, 40));
        setError(null);
      } else {
        // Tamamen ulaşılamadı (Network Error vb.)
        const failedRecord = {
          checkedAt,
          reachable: false,
          httpStatus: err.response?.status || 0,
          status: "UNREACHABLE",
          data: null
        };
        setLatest(failedRecord);
        setHistory((prev) => [failedRecord, ...prev].slice(0, 40));
        setError("Sunucuya ulaşılamıyor.");
      }
    } finally {
      setLoading(false);
      if (isManual) setChecking(false);
    }
  };

  useEffect(() => {
    if (!token) {
      navigate("/login");
      return;
    }

    fetchHealthData();
    const interval = setInterval(() => fetchHealthData(false), 15000); // 15 saniyede bir kontrol et

    return () => clearInterval(interval);
  }, []);

  // Metrik Kartı Tasarımı
  const renderMetricCard = (label, value, subLabel = null) => (
    <Col xs={12} sm={6} md={4} xl={3} className="mb-3">
      <Card style={{ backgroundColor: '#141414', border: '1px solid #262626' }} className="rounded-4 h-100">
        <Card.Body className="d-flex flex-column justify-content-center p-3">
          <div style={{ fontSize: '11px', color: '#8a8a8a', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: '6px' }}>
            {label}
          </div>
          <div style={{ fontSize: '18px', color: '#eaeaea', fontWeight: '500' }}>
            {value || '—'}
          </div>
          {subLabel && (
            <div style={{ fontSize: '12px', color: '#8a8a8a', marginTop: '4px' }}>
              {subLabel}
            </div>
          )}
        </Card.Body>
      </Card>
    </Col>
  );

  // Express JSON yapısından verileri güvenlice çıkaralım
  const d = latest?.data || {};
  const sys = d?.services?.system || {};
  const mem = sys.memory || {};
  const disk = sys.disk;
  const db = d?.services?.database;

  return (
    <div className="app-container">
      {/* Sol Menü */}
      <Navbar />

      {/* Sağ Ana İçerik */}
      <div className="main-content" style={{ padding: '30px' }}>
        <div className="d-flex justify-content-between align-items-center mb-4 flex-wrap gap-2">
          <h2 style={{ color: 'white', margin: 0, fontSize: '22px' }}>Sistem Sağlığı</h2>
          <Button
            onClick={() => fetchHealthData(true)}
            disabled={checking || loading}
            style={{
              backgroundColor: 'transparent',
              borderColor: '#262626',
              color: '#eaeaea',
              fontSize: '13px',
              padding: '8px 16px',
              borderRadius: '8px'
            }}
          >
            {checking ? <Spinner size="sm" animation="border" /> : "Şimdi Yenile"}
          </Button>
        </div>

        {loading ? (
          <div style={{ textAlign: 'center', width: '100%', marginTop: '50px' }}>
            <b style={{ color: "white", fontSize: 20 }}>Yükleniyor...</b>
          </div>
        ) : (
          <>
            {/* Durum Rozeti (Badge) */}
            <div
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: '10px',
                padding: '8px 16px',
                borderRadius: '999px',
                border: '1px solid #262626',
                backgroundColor: '#141414',
                fontSize: '14px',
                color: '#eaeaea',
                marginBottom: '28px'
              }}
            >
              <span
                style={{
                  width: '10px',
                  height: '10px',
                  borderRadius: '50%',
                  backgroundColor: getStatusColor(latest?.status)
                }}
              />
              <span style={{ fontWeight: 'bold' }}>{latest?.status || "BİLİNMİYOR"}</span>
              {latest?.httpStatus > 0 && (
                <span style={{ color: '#8a8a8a', fontSize: '12px' }}>({latest.httpStatus})</span>
              )}
            </div>

            {/* Metrik Izgarası */}
            <Row>
              {renderMetricCard(
                "Ulaşılabilirlik",
                latest?.reachable ? `Erişilebilir` : "Erişim Yok",
                latest?.httpStatus ? `HTTP ${latest.httpStatus}` : null
              )}

              {renderMetricCard(
                "Veritabanı (MongoDB)",
                typeof db === 'string' ? db : "BİLİNMİYOR",
                db === "HEALTHY" ? "Bağlantı aktif" : null
              )}

              {renderMetricCard(
                "Uptime",
                sys.uptime || "—"
              )}

              {renderMetricCard(
                "Event Loop Gecikmesi",
                sys.eventLoopLag || "—",
                parseInt(sys.eventLoopLag) > 100 ? "Uyarı: Gecikme yüksek!" : "Normal değerde"
              )}

              {renderMetricCard(
                "Heap Kullanımı",
                mem.heapUsed && mem.heapTotal ? `${mem.heapUsed} / ${mem.heapTotal}` : "—",
                mem.heapRatio ? `Kullanım: ${mem.heapRatio}` : null
              )}

              {renderMetricCard(
                "RSS (Physical RAM)",
                mem.rss || "—"
              )}

              {renderMetricCard(
                "Disk Durumu",
                typeof disk === 'object' ? `${disk.usedPercentage} Dolu` : (disk || "—"),
                typeof disk === 'object' ? `${disk.free} boş alan (${disk.status})` : null
              )}

              {renderMetricCard(
                "Load Average",
                Array.isArray(sys.loadAverage) ? sys.loadAverage.join(' / ') : "—",
                "[1dk / 5dk / 15dk]"
              )}
            </Row>

            {/* Oturum İçi Kontrol Geçmişi */}
            <div className="mt-4 p-3 rounded-4" style={{ backgroundColor: '#141414', border: '1px solid #262626' }}>
              <div style={{ fontSize: '11px', color: '#8a8a8a', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: '12px' }}>
                Oturum Geçmişi ({history.length} Kontrol)
              </div>
              <div style={{ display: 'flex', gap: '4px', flexWrap: 'wrap', alignItems: 'center' }}>
                {history.slice().reverse().map((h, idx) => (
                  <div
                    key={idx}
                    title={`${h.status} (${h.httpStatus}) — ${formatDate(h.checkedAt)}`}
                    style={{
                      width: '8px',
                      height: '28px',
                      borderRadius: '2px',
                      backgroundColor: getStatusColor(h.status),
                      cursor: 'pointer',
                      transition: 'opacity 0.2s'
                    }}
                    onMouseEnter={(e) => e.target.style.opacity = 0.7}
                    onMouseLeave={(e) => e.target.style.opacity = 1}
                  />
                ))}
                {history.length === 0 && <span style={{ color: '#8a8a8a', fontSize: '13px' }}>Henüz veri yok.</span>}
              </div>
            </div>

            {/* Alt Bilgi & Hatalar */}
            <div className="d-flex justify-content-between align-items-center mt-3 flex-wrap">
              <span style={{ color: '#8a8a8a', fontSize: '12px' }}>
                Son kontrol: {formatDate(latest?.checkedAt)} (Her 15 saniyede bir otomatik yenilenir)
              </span>
              {error && (
                <span style={{ color: '#c0392b', fontSize: '13px' }}>
                  Hata: {error}
                </span>
              )}
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default Health;